module.exports = __webpack_public_path__ + "9fb66351d04c4194074a5e96a4673f05.MP3";